<section class="legal-page">
  <div class="container">
    <header class="legal-page__head">
      <h1 class="legal-page__title">{{ titleKey | translate }}</h1>
      <p class="legal-page__updated">{{ updatedKey | translate }}</p>
    </header>

    @if (introKey) {
    <p class="legal-page__intro " [innerHTML]="introKey"></p>
    }

    @for (section of sections; track section.id ?? section.name; let idx = $index) {
    <div class="legal-page__section fs-5">
      <h3 class="legal-page__section-title text-gray-800">{{ idx + 1 }}. {{ section.name }}</h3>
      <div class="legal-page__body" [innerHTML]="section.content"></div>
    </div>
    }

    @if (demo.enabled) {
    <p class="legal-page__note">{{ "LEGAL.DEMO_NOTE" | translate }}</p>
    }
  </div>
</section>